import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { NotificationService } from '../services/notification.service';
import * as notificationActions from './notification.actions';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
  ) {}

  // ─── Load Notifications ────────────────────────────────────────────────────

  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationActions.LoadNotifications),
      switchMap(({ params }) =>
        this.notificationService.getNotifications(params).pipe(
          map((res) =>
            notificationActions.LoadNotificationsSuccess({
              notifications: res.data,
              metadata: res.metadata,
            })
          ),
          catchError(() => of(notificationActions.LoadNotificationsError()))
        )
      )
    )
  );

  // ─── Mark As Read ──────────────────────────────────────────────────────────

  markAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationActions.MarkAsRead),
      switchMap(({ id }) =>
        this.notificationService.markAsRead(id).pipe(
          map(() => notificationActions.MarkAsReadSuccess({ id })),
          catchError(() => of(notificationActions.MarkAsReadError({ id })))
        )
      )
    )
  );

  // ─── Mark All As Read ──────────────────────────────────────────────────────

  markAllAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationActions.MarkAllAsRead),
      switchMap(() =>
        this.notificationService.markAllAsRead().pipe(
          map((res) =>
            notificationActions.MarkAllAsReadSuccess({ updatedCount: res.object.updated })
          ),
          catchError(() => of(notificationActions.MarkAllAsReadError()))
        )
      )
    )
  );
}
